import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { IntegrationsHttpApiService } from '@core/integrations-http-legacy';
import type {
  JobBoardCredential,
  JobBoardCredentialCreateParams,
  JobBoardCredentialUpdateParams,
} from '@recruitee/job-boards-types';

@Injectable({ providedIn: 'root' })
export class JobBoardCredentialHttpClient {
  private readonly http = inject(IntegrationsHttpApiService);

  public fetch(codename: string): Observable<JobBoardCredential[]> {
    return this.http
      .get(`job-boards/${codename}/credentials`, null, { context: 'job-boards' })
      .pipe(map(({ credentials }: { credentials: JobBoardCredential[] }) => credentials));
  }

  public createCredential(
    codename: string,
    params: JobBoardCredentialCreateParams,
  ): Observable<JobBoardCredential> {
    return this.http
      .post(`job-boards/${codename}/credentials`, undefined, params, { context: 'job-boards' })
      .pipe(map(({ credential }: { credential: JobBoardCredential }) => credential));
  }

  public updateCredential(
    codename: string,
    credentialId: number,
    params: JobBoardCredentialUpdateParams,
  ): Observable<JobBoardCredential> {
    return this.http
      .patch(`job-boards/${codename}/credentials/${credentialId}`, undefined, params, {
        context: 'job-boards',
      })
      .pipe(map(({ credential }: { credential: JobBoardCredential }) => credential));
  }

  public deleteCredential(codename: string, credentialId: number): Observable<JobBoardCredential> {
    return this.http
      .delete(`job-boards/${codename}/credentials/${credentialId}`, null, { context: 'job-boards' })
      .pipe(map(({ credential }: { credential: JobBoardCredential }) => credential));
  }

  public validateCorporateEmail(email: string): Observable<any> {
    return this.http.post('validate-corporate-email', undefined, { email });
  }
}
